import {unaVez} from "../lib/eventos";

const popup = () => {
    [].forEach.call(document.querySelectorAll('.popup'), (popup: HTMLElement) => {
        popup.remove();

        let elementosPrincipales: HTMLElement[] = [];

        if (popup.id && localStorage.getItem(`popup-${popup.id}`)) {
            return;
        }

        let elementoConFoco: Element | null;

        const retardo = parseInt(popup.getAttribute('data-retardo') || '0'),
            cierra = () => {
                if (popup.id) {
                    localStorage.setItem(`popup-${popup.id}`, (new Date()).toISOString());
                }

                popup.setAttribute('aria-hidden', 'true');
                unaVez(popup, 'transitionend', () => popup.remove());
                elementosPrincipales.forEach((elemento) => elemento.inert = false);
                (elementoConFoco as HTMLElement)?.focus();
            };

        setTimeout(() => {
            elementoConFoco = document.activeElement;

            elementosPrincipales = Array.from(document.querySelectorAll<HTMLElement>('html > *'));

            elementosPrincipales.forEach((elemento) => elemento.inert = true);

            document.documentElement.appendChild(popup);
            requestAnimationFrame(() => {
                popup.setAttribute('aria-hidden', 'false');
            });
            popup.focus();
        }, retardo);

        popup.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            if (target === popup || target.closest('.popup__cerrar') || target.closest('.popup__boton--cerrar') || target.closest('.popup__boton')) {
                cierra();
            }
        });
    });
}

export default popup;